import styled from 'styled-components';
import { Currency } from 'ui-toolkit';

export const ColorCurrency = styled(Currency)<{ isNegative: boolean; manuallyEdited?: boolean }>`
  color: ${({ manuallyEdited, isNegative, theme }) => {
    if (manuallyEdited) {
      return theme.colors.darkGray;
    }
    if (isNegative) {
      return theme.colors.warning;
    }
    return theme.colors.defaultContentText;
  }};
`;

export const isNegative = (val: string | number) => {
  const numero = Number(val);
  return !Number.isNaN(numero) && numero < 0;
};
